export const Loader = $("#loader");
export function ShowLoader() {
    Loader.show();
}
export function HideLoader() {
    Loader.hide();
}